module.exports = __webpack_public_path__ + "img/icon_box_3_3.7f53dc04.png";